/**
 * @generated SignedSource<<4f045c7c66fbd7b4221935db1e6fd624>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteSidebar_seoRoute$data = {
  readonly jsonParams: ReadonlyArray<{
    readonly name: string | null;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "SeoRouteJsonParams_seoRoute">;
  readonly " $fragmentType": "SeoRouteSidebar_seoRoute";
};
export type SeoRouteSidebar_seoRoute$key = {
  readonly " $data"?: SeoRouteSidebar_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRouteSidebar_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRouteSidebar_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SeoRouteJsonParam",
      "kind": "LinkedField",
      "name": "jsonParams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoRouteJsonParams_seoRoute"
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "34aea68aaed72c1d64ab3ffc35b7b99d";

export default node;
